<template>
  <div :class="wrapperClass">
    <div class="flex items-center">
      <SfCheckbox
        v-bind="$attrs"
        :id="`${id}-checkbox`"
        v-model="value"
        :data-testid="`${id}-checkbox`"
        :disabled="disabled"
        :invalid="invalid"
      />
      <slot v-if="!label" />
      <UiText
        v-else
        type="label"
        :size="labelSize"
        :for="`${id}-checkbox`"
        class="ml-3 cursor-pointer"
        :class="[{ '!text-disabled-500': disabled }]"
      >
        {{ label }}
      </UiText>
    </div>
    <UiErrorMessage v-if="invalid && errorMessage" :message="errorMessage" />
    <UiHelpText v-if="helpText" :text="helpText" />
  </div>
</template>

<script setup lang="ts">
import type { CheckboxProps } from '~/components/ui/Checkbox/types';

const props = defineProps<CheckboxProps>();

const value = ref<boolean>(props.checked);

watch(
  () => props.checked,
  () => (value.value = props.checked),
);
defineOptions({
  inheritAttrs: false,
});
</script>
